let defaultTTL = 60;
window.addEventListener('logout', () => {
  // clear the data from localStorage when a user logs out
  clearAllCache();
});
export async function cacheable<T>(fn: () => Promise<T>, key: string, defaultValue: T, ttlInMinute: number) {
  let result;
  try {
    // save the data to localStorage.
    const cache = getCache(key);
    if (cache == null) {
      // retrieve the data from backend.
      result = await fn();
      setWithExpiry(key, JSON.stringify(result), ttlInMinute * 60000);
    } else result = JSON.parse(cache);
  } catch {
    // if failed to retrieve the data from backend, try localStorage.
    const cached = getCache(key);
    // use the cached data if available, otherwise the default value.
    result = cached === undefined ? defaultValue : JSON.parse(cached);
  }
  return result;
}
function getCache(key): any {
  return getWithExpiry(key);
}
function clearCache(key) {
  localStorage.removeItem(key);
}
function clearAllCache() {
  localStorage.clear();
}
function setWithExpiry(key, value, ttl) {
  const now = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}
function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}
